module.exports = __webpack_public_path__ + "static/media/el fath still 01-mobile.447ff74a.webp";